module.exports = __webpack_public_path__ + "img/fastplus-indicator.73bed064.png";